import * as React from "react";
import * as ReactDOM from "react-dom";
import {LogoutPanelStatus, LogoutPanel} from "./LogoutPanel";

export interface LogoutItem {
    key: string;
    title: string;
    status: LogoutPanelStatus;
}

export interface LogoutPageProps extends React.Props<LogoutPage> {
}

export interface LogoutPageState {
    items: LogoutItem[];
}

export class LogoutPage extends React.Component<LogoutPageProps, LogoutPageState> {
    constructor(props) {
        super(props);

        this.state = {
            items: []
        };
    }

    public render(): JSX.Element {
        var haveFailures = false;
        var panels: JSX.Element[] = [];
        for (let item of this.state.items) {
            if (item.status === LogoutPanelStatus.Failure) {
                haveFailures = true;
            }
            panels.push(
                <LogoutPanel key={item.key} title={item.title} status={item.status} />
            );
        }
        return (
            <div className="">
                <h1>Sign-out in progress...</h1>
                <p>Please wait while we sign you out of the following applications: </p>
                {panels}
                {haveFailures ? <p className="sign-out-failed">Could not sign you out of one or more applications.</p> : null}
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./Client/Views/LogoutPage.tsx